import { Dispatch, SetStateAction, useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, FormHelperText } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function SetCustomerHealthScore({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [scores, setScores] = useState({
        recency: "",
        frequency: "",
        monetary: "",
        refunds: "",
        supportTickets: "",
    });

    const [error, setError] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setScores({ ...scores, [e.target.name]: e.target.value });
    };

    const validateScores = () => {
        const total = Object.values(scores).reduce((acc, val) => acc + (Number(val) || 0), 0);
        if (total !== 100) {
            setError(`Total score must be 100%. Current total: ${total}%`);
            return false;
        }
        setError(null);
        return true;
    };

    const handleSave = () => {
        if (validateScores()) {
            console.log("Saved Scores:", scores);
            setOpen(false);
        }
    };

    // Clear error when inputs change
    useEffect(() => {
        const total = Object.values(scores).reduce((acc, val) => acc + (Number(val) || 0), 0);
        if (total > 100) {
            setError(`Total score exceeds 100%. Current total: ${total}%`);
        } else if (error) {
            setError(null);
        }
    }, [scores]);


    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Set Customer Health Score</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <div className="form">
                        <div className="gap_p">

                            {/* Recency */}
                            <div className="control_group w_50">
                                <label htmlFor="chs-recency">Recency (%)</label>
                                <TextField
                                    name="recency"
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "chs-recency" }}
                                    fullWidth
                                    hiddenLabel
                                    value={scores.recency}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Frequency */}
                            <div className="control_group w_50">
                                <label htmlFor="chs-frequency">Frequency (%)</label>
                                <TextField
                                    name="frequency"
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "chs-frequency" }}
                                    fullWidth
                                    hiddenLabel
                                    value={scores.frequency}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Monetary */}
                            <div className="control_group w_50">
                                <label htmlFor="chs-monetary">Monetary (%)</label>
                                <TextField
                                    name="monetary"
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "chs-monetary" }}
                                    fullWidth
                                    hiddenLabel
                                    value={scores.monetary}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Refunds */}
                            <div className="control_group w_50">
                                <label htmlFor="chs-refunds">Refunds (%)</label>
                                <TextField
                                    name="refunds"
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "chs-refunds" }}
                                    fullWidth
                                    hiddenLabel
                                    value={scores.refunds}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Support Tickets */}
                            <div className="control_group w_50">
                                <label htmlFor="chs-support">Support Tickets (%)</label>
                                <TextField
                                    name="supportTickets"
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "chs-support" }}
                                    fullWidth
                                    hiddenLabel
                                    value={scores.supportTickets}
                                    onChange={handleChange}
                                />
                            </div>

                            {error && (
                                <div className="control_group w_100">
                                    <FormHelperText error>{error}</FormHelperText>
                                </div>
                            )}

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={handleSave}
                            >
                                Save Score
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </Modal>
    );
}
